import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { memo } from 'react';

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    fill: theme.palette.success.main,
  },
}));

function Chute(props: SvgIconProps) {
  const { classes } = useStyles();

  return (
    <SvgIcon {...props} viewBox="0 0 25 24">
      <path
        className={classes.root}
        d="M22.27 2.63a1.4 1.4 0 012.16 0c.54.62.6 1.59.15 2.27l-.15.2-11.38 12.19c-.54.62-1.39.67-1.99.17l-.17-.17-4.6-4.99c-.6-.68-.6-1.78 0-2.46a1.4 1.4 0 011.99-.17l.17.17 3.52 3.75 10.3-10.96z"
      />
      <path
        className={classes.root}
        d="M12 4a8.2 8.2 0 108.03 9.85l3.06-3.26.01.11a11.2 11.2 0 11-4.85-7.8l-2.11 2.22A8.15 8.15 0 0012 4z"
      />
    </SvgIcon>
  );
}

export default memo(Chute);
